import { CSSProperties } from "react";
import WorkLog from "../models/WorkLog";
import { Token } from "../theme";

export interface WorkLogRowContext {
  expectedExternalHours: number;
  expectedInternalHours: number;
  isTimeOff: boolean;
  isAssignationActive: boolean;
  isEndOfWorkWeek: boolean;
}

const mark = (color: string): CSSProperties => ({ boxShadow: `inset 3px 0 0 ${color}` });

export const workLogRowStyles = (instance: WorkLog, ctx: WorkLogRowContext): CSSProperties | undefined => {
  if (instance.isWeekend) return { backgroundColor: Token.surfaceSunken };
  if (instance.isHoliday) return mark(Token.statusInfoFg);
  if (ctx.isTimeOff) return mark(Token.timeoffFg);
  if (instance.isPaused || !ctx.isAssignationActive) return mark(Token.textTertiary);

  if (!instance.externalId) {
    return { backgroundColor: Token.statusWarningBg, ...mark(Token.statusWarningFg) };
  }

  if (instance.hours < ctx.expectedExternalHours || instance.internalHours < ctx.expectedInternalHours) {
    return mark(Token.brandAccent);
  }

  if (ctx.isEndOfWorkWeek) return { borderBottom: `10px ${Token.borderDefault} solid` };

  return undefined;
};
